import React, { Component } from "react";
import { connect } from "react-redux";
import { string, bool, func } from "prop-types";

import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { actions as settingsActions } from "reducers/settings";

import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import { Mixpanel } from "util/clickstreaming";
import { TERMS_AND_CONDITIONS_CATEGORY_PF } from "../../../util/onboarding";

const FORM_ID = "login.step4";

class Step4Content extends Component {
    acceptConditions = () => {
        Mixpanel.track(FORM_ID, { acceptConditions: true });
        this.props.dispatch(loginActions.loginStep4(true));
    };

    handleClickDownloadPdf = () => {
        const { dispatch, fileName, activeEnvironment } = this.props;
        dispatch(settingsActions.downloadDocumentRequestWithIdEnv(fileName, "termsAndConditions", activeEnvironment));
    };

    render() {
        const { termsAndConditions, isSubmitting, onCancel } = this.props;
        return (
            <>
                <div className="above-the-fold login-desktop-wrapper">
                    {termsAndConditions &&
                        <I18n defaultValue={termsAndConditions}></I18n>
                    }
                </div>

                <button
                    id="btn-downloaPDF"
                    type="button"
                    className="btn btn-asLink"
                    onClick={() => this.handleClickDownloadPdf()}>
                    <I18n id="generalConditions.term.download" />
                </button>

                <div className="form-actions">
                    <Button
                        loading={isSubmitting}
                        label="global.accept"
                        bsStyle="primary"
                        onClick={this.acceptConditions}
                        block
                    />
                    <Button label="global.cancel" bsStyle="outline" onClick={onCancel} block />
                </div>
            </>
        );
    }
}

Step4Content.propTypes = {
    isSubmitting: bool,
    onCancel: func.isRequired,
    dispatch: func.isRequired,
    termsAndConditions: string.isRequired,
    fileName: string,
};

Step4Content.defaultProps = {
    isSubmitting: false,
    fileName: "",
};

const mapStateToProps = (state) => ({
    isSubmitting: loginSelectors.getFetching(state),
    activeEnvironment: loginSelectors.getEnvironmentIdTemp(state),
});

export default connect(mapStateToProps)(Step4Content);
